import React, { useState, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import './Detail.scss';
import common from '../../common';
import axios from 'axios';

import { Comment, TableList } from "../../components";
import { useSelector } from 'react-redux';
import { AiOutlineLike , AiFillLike } from 'react-icons/ai';


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const { useModal } = common();

function Detail() {

    const member_idx = useSelector((state) => state.user.loginInfo || null);


    const { pToast, useAlert, useConfirm, useLoading } = common();
    const { pAlert, AlertComponent } = useAlert();
    const { pModal, ModalComponent} = useModal();
    const { pConfirm, ConfirmComponent} = useConfirm();
    const { pLoadingOn, pLoadingOff, LoadingComponent } = useLoading();
    const [data, setData] = useState([]);
    
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const targetIdx = queryParams.get('id');
    const type = queryParams.get('type');


    const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 1024);
    const [isMobileView2, setIsMobileView2] = useState(window.innerWidth <= 768);

    const handleResize = () => {
        setIsMobileView(window.innerWidth <= 1024);
        setIsMobileView2(window.innerWidth <= 768);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const fetchData = async () => {
        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/yehs_document/out/get_detail`, { 
                idx: parseInt(targetIdx), 
                type: type
            } , {
                withCredentials: true
            });

            if (response.data.result === 't') {
                const data = response.data.data;
                setData(data)
            } else {
                pAlert(response.data.msg);
            }
        } catch (error) {
            console.error('Data fetching failed:', error);
        } finally {
            pLoadingOff();
        }
    }



    const fetchCountData = async () => {
        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/yehs_document/out/view_count`, { idx: parseInt(targetIdx),type: type } , {
                withCredentials: true
            });

            if (response.data.result === 't') {
                
            } else {
                pAlert(response.data.msg);
            }
        } catch (error) {
            console.error('Data fetching failed:', error);
        } finally {
            pLoadingOff();
        }
    }


    useEffect(() => {
        fetchCountData();
    }, []);

    useEffect(() => {
        fetchData();
    }, []);

    
    const handleFileDownload = async (idx, serverName, fileName) => {

        
        try {
            pLoadingOn();

            let fileType = '';
            if(type === 'Event'){
                fileType = 'ev';
            }else if (type === 'document'){
                fileType = 'do';
            }

            const fileFormData = new FormData();
            fileFormData.append('type', fileType);
            fileFormData.append('idx', idx);
            fileFormData.append('serverName', serverName);
            fileFormData.append('name', fileName);

            const response = await axios.post(`${API_BASE_URL}/yehs_document/out/get_file`, fileFormData , {
                withCredentials: true,
                responseType: 'blob'  // 응답 타입을 blob으로 설정
            });

            if (response.status === 200) { // HTTP 응답 상태 코드가 200인 경우
                const blob = response.data;
                const downloadUrl = window.URL.createObjectURL(blob);

                // Blob을 사용하여 파일 다운로드
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // Blob URL을 해제
                window.URL.revokeObjectURL(downloadUrl);
            } else {
                pAlert('파일 다운로드에 실패했습니다.');
            }

        } catch (error) {
            pAlert(`파일다운에 실패했습니다. 다시 시도해 주세요.`);
        } finally {
            pLoadingOff();
        }
    };





    const handleSubmit = async( type ) => {
        if (!member_idx || (typeof member_idx === 'object' && Object.keys(member_idx).length === 0)) {
            pAlert(`로그인 상태에서 행사 ${type} 하실 수 있습니다.`);
            return false;
        }
        const event_idx = parseInt(targetIdx);
        
        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/yehs_event/in/yehs_event_register`, {event_idx : event_idx , status_name : type}, {
                withCredentials: true
            });
    
            if (response.data.result === 't') {
                pAlert(`${type} 신청이 완료되었습니다.`);
                
                await fetchData();
                await fetchEventListData();
            } else {
                pAlert(response.data.msg);
            }
        } catch (error) {
            pAlert('실패함.');
        } finally {
            pLoadingOff();
        }
    };

    // const [likedComments, setLikedComments] = useState([]);
    const handleLike = async (targetIdx) => {
        if (!member_idx || (typeof member_idx === 'object' && Object.keys(member_idx).length === 0)) {
            pAlert('로그인 상태에서 추천하실 수 있습니다.');
            return false;
        }
        
        const likeData = {
            targetIdx: targetIdx,
            memberIDX: member_idx,
            type: type
        };

        try {
            // 서버에 좋아요 요청 보내기
            const response = await axios.post(`${API_BASE_URL}/yehs_document/in/like_update`, likeData, {
                withCredentials: true
            });

            if (response.data.result === 't') {
                if (data.likeStatus === 'N') {
                    pToast('추천되었습니다.');
                } else if (data.likeStatus === 'Y') {
                    pToast('추천이 취소되었습니다.');
                }
                
                await fetchData();
            } else {
                pAlert(response.data.msg);
            }
        } catch (error) {
            console.error('Data fetching failed:', error);
        }
    };


















    

    const handleDelete = async (e) => {
        e.preventDefault();

        if (!member_idx || (typeof member_idx === 'object' && Object.keys(member_idx).length === 0)) {
            pAlert('로그인 상태에서 삭제하실 수 있습니다.');
            return false;
        }

        pConfirm(
            '게시글 삭제',
            <>
                <div>해당 게시글을 삭제 하시겠습니까?</div>
            </>,
            '400px',
            'auto',
            async () => {
                try {
                    const response = await axios.post(`${API_BASE_URL}/yehs_document/in/user_document_delete`, {targetIdx : parseInt(targetIdx)}, {
                        withCredentials: true
                    });
                    if (response.data.result === 't') {
                        pAlert('게시물 삭제가 완료되었습니다.');
                        setTimeout(()=>{
                            if(data.documentCategoryIDX === 8){
                                window.location.href = `/questionBoard`;
                            }else if(data.documentCategoryIDX === 9){
                                window.location.href = `/freeBoard`;
                            }else if(data.documentCategoryIDX === 3){
                                window.location.href = `/promotionBoard`;
                            }
                        },1500);
                    } else {
                        pAlert(response.data.msg);
                    }
                } catch (error) {
                    console.error('등록 실패:', error);
                    pAlert('등록에 실패했습니다. 다시 시도해 주세요.');
                } finally {
                    pLoadingOff();
                }
            }
        );
    };











    const handleEditBoard = () => {
        window.location.href = '/board?cateIdx='+data.documentCategoryIDX+'&targetIdx='+targetIdx+'&boardType=edit';
    };





















    const tableLoadData = {
        tableType: 'Event',
        idx: targetIdx,
    };

    const fetchEventListData = async () => {
        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/yehs_document/in/event_attend_list`, tableLoadData, {
                withCredentials: true
            });

            if (response.data.result === 't') {
                const data = response.data.data;
                const dataCount = data.length;
                setEventAttendData(data);
                setEventAttendCount(dataCount);
            } else {
                pAlert(response.data.msg);
            }
        } catch (error) {
            console.error('Data fetching failed:', error);
        } finally {
            pLoadingOff();
        }
    };


    const [eventAttenData, setEventAttendData] = useState([]);
    const [eventAttenCount, setEventAttendCount] = useState('');

    // useEffect, useMemo 훅은 조건과 상관없이 최상단에서 호출
    useEffect(() => {
        if (member_idx && (typeof member_idx !== 'object' || Object.keys(member_idx).length > 0) && type === 'Event') {

            fetchEventListData();
        }
    }, [member_idx, type, targetIdx]);

    const columns = useMemo(() => {
        if (member_idx && (typeof member_idx !== 'object' || Object.keys(member_idx).length > 0) && type === 'Event') {
            return [
                // { title: '신청일', dataIndex: 'createTime', className: '' },
                { title: '구분', dataIndex: 'grade', className: '' },
                { title: '이름', dataIndex: 'name', className: '' },
                { title: '학교/학과', dataIndex: 'user_university', className: '' },
                { title: '직장', dataIndex: 'job', className: '' },
                // { title: '연락처', dataIndex: 'phone', className: '' },
                { title: '상태', dataIndex: 'status', className: '' },
                { title: '비고', dataIndex: 'ex', className: 'p_td_w_30' },
            ];
        }
        return [];
    }, [member_idx, type]);

    const pageSize = 10;

    const categoryOptions = useMemo(() => {
        if (member_idx && (typeof member_idx !== 'object' || Object.keys(member_idx).length > 0) && type === 'Event') {
            return [
                { label: '전체', value: '전체' },
                { label: '이름', value: 'name' },
            ];
        }
        return [];
    }, [member_idx, type]);
    




    return (
        <>
            <ModalComponent/>
            <AlertComponent/>
            <ConfirmComponent/>
            <LoadingComponent/>
            <div className="components_wrap">
                <div className='p_detail_wrap'>
                    <div className="p_detail_header_box">
                        <div className='p_detail_header'>
                            {type === 'Event' ? (
                                // 'Evnet'일 때 렌더링할 JSX
                                <>
                                    <h1>[{data.eventCateName || '기타'}] {data.title}</h1>
                                    <div className='p_detail_meta'>
                                        <span className='date'>{data.date}</span>
                                        <span className='place'>{data.place || '-'}</span>
                                        <span className='views'>
                                            <img src="/img/views.png" alt="views" />
                                            {data.view}
                                        </span>
                                        {isMobileView2 ? (
                                            <span className="comment_likes" onClick={() => handleLike(data.idx)}>
                                                {data.likeStatus === 'Y' ? <AiFillLike className='likes_icon'/> : <AiOutlineLike className='likes_icon'/>} {data.likeCount || 0}
                                            </span>
                                        ):null}
                                    </div>
                                </>
                            ) : type === 'document' ? (
                                // 'document'일 때 렌더링할 JSX
                                <>
                                    <h1>  {data.headCate ? (
                                        <span>[{data.headCate}]</span>
                                    ):(
                                        <></>
                                    )} {data.title}</h1>
                                    <div className='p_detail_meta'>
                                        <span className='date'>{data.createTime || '0000-00-00'}</span>
                                        <span className='place'>{data.writer || '관리자'}</span>
                                        <span className='views'>
                                            <img src="/img/views.png" alt="views" />
                                            {data.view}
                                        </span>
                                        {isMobileView2 ? (
                                            <span className="comment_likes" onClick={() => handleLike(data.idx)}>
                                                {data.likeStatus === 'Y' ? <AiFillLike className='likes_icon'/> : <AiOutlineLike className='likes_icon'/>} {data.likeCount || 0}
                                            </span>
                                        ):null}
                                    </div>
                                </>
                            ) : (
                                // 그 외의 경우 렌더링할 JSX (optional)
                                <></>
                            )}
                            
                        </div>
                        <div className="p_detail_like_box">
                            {!isMobileView2 ? (
                                <span className="comment_likes c_l_f_22" onClick={() => handleLike(data.idx)}>
                                    {data.likeStatus === 'Y' ? <AiFillLike className='likes_icon'/> : <AiOutlineLike className='likes_icon'/>} {data.likeCount || 0}
                                </span>
                            ):null}
                        </div>
                    </div>
                    
                    
                        {/* 기타 내용 */}
                    <div className='p_detail_content' dangerouslySetInnerHTML={{ __html: data.contents }} />
                    

                    {data.file && data.file.length > 0 && (  // 파일 배열이 존재하고 길이가 0보다 클 때만 렌더링
                        <div className='p_detail_file_box'>
                            <span>첨부파일</span>
                            <div className="p_detail_file_down_box">
                                {data.file.map((file, index) => (
                                    <button 
                                        key={file.idx} 
                                        className='p_detail_file_down_btn'
                                        onClick={() => handleFileDownload(file.idx,file.serverName, file.name)} 
                                    >
                                        {file.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}




                    {(!member_idx || (typeof member_idx === 'object' && Object.keys(member_idx).length === 0)) ? (
                        <>
                        </>
                    ):(
                        <>
                        {type === 'Event' ? (
                            <>
                            {data.distinction === 'NOW' ? (
                                <div className="p_event_register_btn_box">
                                    {data.registerStatus === 'N' ? (
                                        <>
                                            <button 
                                                className='p_event_register_btn' 
                                                onClick={() => pConfirm(
                                                    '', 
                                                    '행사 신청을 하시겠습니까?', 
                                                    '350px', 
                                                    'auto', 
                                                    () => handleSubmit('참가'), // '참가'를 파라미터로 전달
                                                    '확인', 
                                                    '취소'
                                                )}
                                            >
                                                신청
                                            </button>
                                        </>
                                    ):(
                                        <>
                                            <button 
                                                className='p_event_absence_btn' 
                                                onClick={() => pConfirm(
                                                    '', 
                                                    '해당 행사를 불참 하시겠습니까?', 
                                                    '350px', 
                                                    'auto', 
                                                    () => handleSubmit('불참'), // '불참'을 파라미터로 전달
                                                    '확인', 
                                                    '취소'
                                                )}
                                            >
                                                불참
                                            </button>
                                        </>
                                    )}
                                </div>
                            ) : data.distinction === 'BEFORE' ? (
                                <div className="p_event_register_btn_box">
                                    <span>신청 대기중인 행사입니다.</span>
                                </div>
                            ) : (
                                <div className="p_event_register_btn_box">
                                    <span>신청이 마감된 행사입니다.</span>
                                </div>
                            )}
                            </>
                        ) : (
                            <>
                                {data.documentCategoryIDX === 3 || data.documentCategoryIDX === 8 ||data.documentCategoryIDX === 9 ? (
                                    <>
                                    <div className="p_event_register_btn_box">
                                        {data.myDocument === 'Y' ? (
                                            <>
                                                <button
                                                className='p_document_delete_btn'
                                                onClick={handleDelete}>
                                                    삭제
                                                </button>
                                                <button
                                                className='p_document_edit_btn'
                                                onClick={handleEditBoard}
                                                >
                                                    수정
                                                </button>
                                            </>
                                        ):(
                                            <></>
                                        )}
                                        </div>
                                    </>
                                ):(
                                    <></>
                                )}
                            </>
                        )}

                        </>
                    )}



                    
































                    {type === 'Event' ? (
                        <>
                            {(!member_idx || (typeof member_idx === 'object' && Object.keys(member_idx).length === 0)) ? (
                                <>
                                </>
                            ):(
                                <>
                                <div className="p_event_register_list_box">
                                    <span className='p_event_attend_title'>참여 회원 리스트</span>
                                    <TableList data={eventAttenData} columns={columns} pageSize={pageSize} categoryOptions={categoryOptions} type={"EventRegist"} eventAttenCount={eventAttenCount} />
                                </div>
                                </>
                            )}
                        </>
                    ) : (
                        <>
                            
                        </>
                    )}
                </div>
                



                <Comment />
            </div>
        </>
    );
}

export default Detail;
